import { render, staticRenderFns } from "./studyResult.vue?vue&type=template&id=3f6857f4&scoped=true&"
import script from "./studyResult.vue?vue&type=script&lang=js&"
export * from "./studyResult.vue?vue&type=script&lang=js&"
import style0 from "./studyResult.vue?vue&type=style&index=0&id=3f6857f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6857f4",
  null
  
)

export default component.exports